import React from 'react';
import Modal from 'components/Modal';
import { Step } from 'components/SteppedModal';
import LinkedInSwitchAccount from 'containers/LinkedInPostModal/LinkedInSwitchAccount';
import { LinkedInSocialShareStep } from '../../types';

export type UseLinkedInSwitchAccountStepConfig = {
  authenticate: () => void;
};

export default function useLinkedInSwitchAccountStep({
  authenticate,
}: UseLinkedInSwitchAccountStepConfig): Step<LinkedInSocialShareStep> {
  return {
    id: 'switch-account',
    component: <LinkedInSwitchAccount />,
    fluidFooterButtons: true,
    renderFooterButtons: () => [
      <Modal.FooterButton
        size="large"
        theme="submit-alt"
        onClick={authenticate}
      >
        I have already signed out
      </Modal.FooterButton>,

      <Modal.FooterButton
        size="large"
        theme="submit"
        href="https://linkedin.com"
        rel="noopener noreferrer"
        target="_blank"
      >
        go to linkedin
      </Modal.FooterButton>,
    ],
  };
}
